import { render, staticRenderFns } from "./issfaview.vue?vue&type=template&id=72e06216&scoped=true&"
import script from "./issfaview.vue?vue&type=script&lang=js&"
export * from "./issfaview.vue?vue&type=script&lang=js&"
import style0 from "./issfaview.vue?vue&type=style&index=0&id=72e06216&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e06216",
  null
  
)

export default component.exports